import React from 'react'

import { LoadingOverlayWrapper, LoadingItem } from '../StyledComponents/Global/Loader'

const LoadingOverlay = () => (
    <LoadingOverlayWrapper>
        <LoadingItem name="circle" color="var(--cyan)" />
    </LoadingOverlayWrapper>
)

export default LoadingOverlay



// WEBPACK FOOTER //
// ./src/components/Global/LoadingOverlay.js